import React, { useEffect, useState } from "react";

import { Breadcrumbs } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import SubHeader from "../../../../../components/Generic/SubHeader";
import { PRIVATE_ROUTES } from "../../../../../constants";
import { Details } from "../components/Details";
import { Forms } from "../components/Forms";
import { MovementProvider } from "../context/MovementContext";
import useStyles, { Content } from "./styles";
import { useAppState } from "Context/StateContext";
import { checkResourceCan, FN_NAMES, hasPermission, isShowAction } from "Util/permissions";
import { ResourceCanEnum, ResourceName } from "Util/enums/accessRule";

export const MovementMaintenace = () => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const history = useHistory();
  const { currentUser, userPermissions } = useAppState();
  const [movementPermission, setMovementPermission] = useState<{
    create: boolean;
  }>({
    create: false,
  });

  useEffect(() => {
    if (userPermissions && userPermissions?.length > 0) {
      setMovementPermission({
        create:
          checkResourceCan(userPermissions, ResourceName.MOVEMENT, ResourceCanEnum.EDIT) &&
          hasPermission(userPermissions, FN_NAMES.FUNCTION_WAREHOUSING_MOVEMENT_ADD_NEW),
      });
    }
  }, [userPermissions]);

  const renderFormByPermission = () => {
    if (!isShowAction(currentUser, movementPermission.create)) return null;

    return (
      <React.Fragment>
        <SubHeader showWarehouseSelect title={translate("movement")}></SubHeader>
        <MovementProvider>
          <Content>
            <Forms />
            <Details />
          </Content>
        </MovementProvider>
      </React.Fragment>
    );
  };

  return renderFormByPermission();
};
